import React, { useState, useEffect } from "react";
import { Table, Space, Button, Row, Col, Input, Modal, notification, Select, Tooltip, Pagination } from "antd";
import { EditOutlined, SearchOutlined, EyeOutlined, DeleteOutlined } from "@ant-design/icons";
import TariffModalForm from "./ModalForm";
import { towingTariffService } from "../../../services";
import { changeDocumentTitle } from "../../../utils/title";

function TowingTariff() {
  const [isModalshow, setIsModalShow] = useState();
  const [loading, setLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [refresh, setRefresh] = useState(true)
  const [modalVisible, setModalVisible] = useState(false);
  const [editData, setEditData] = useState(null);
  const [search, setSearch] = useState(null)
  const [pagination, setPagination] = useState({
    current: 1,
    total: 0,
    pageSize: 10,
  });
  const [tariff, setTariff] = useState([]);
  const [selectedDeleteRecordId, setSelectedDeleteRecordId] = useState();
  const [tariffRecord, setTariffRecord] = useState();

  const options = [
    {
      value: "10",
      label: "10",
    },
    {
      value: "25",
      label: "25",
    },
    {
      value: "50",
      label: "50",
    },
  ];

  const columns = [
    {
      title: "Id",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Auction",
      dataIndex: "auctions",
      key: "Auction",
      render: (text) => text.split(" ").map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(" ")
    },
    {
      title: "USD",
      dataIndex: "usd",
      key: "USD",
    },
    {
      title: "State",
      dataIndex: "state",
      key: "State",
      render: (text) => text.split(" ").map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(" ")
    },
    {
      title: "Code",
      dataIndex: "state_code",
      key: "Code",
    },
    {
      title: "Ports",
      dataIndex: "ports",
      key: "Ports",
    },
    {
      title: "Actions",
      key: "Actions",
      render: (text, record) => (
        <Space size="small">
          <Tooltip title='Edit'>
            {/* <Button
              type="primary"
              size="small"
              onClick={() => {
                handleEdit(record);
              }}
            > */}
            <EditOutlined onClick={() => {
              handleEdit(record);
            }} />
            {/* </Button> */}
          </Tooltip>

          <Tooltip title='View'>
            {/* <Button
              type="primary"
              size="small"
              onClick={() => {
                handleOpenModal(record.id);
              }}
            > */}
            <EyeOutlined onClick={() => {
              handleOpenModal(record.id);
            }} />
            {/* </Button> */}
          </Tooltip>

          <Tooltip title='Delete'>
            {/* <Button
              type="primary"
              size="small"
              onClick={() => showModalHandler(record.id)}
            > */}
            <DeleteOutlined onClick={() => showModalHandler(record.id)} />
            {/* </Button> */}
          </Tooltip>
        </Space>
      ),
    },
  ];

  const getTariff = async (id) => {
    const { success, data } = await towingTariffService.view(id);
    if (success ?? false) {
      setTariffRecord(data);
    }
  };

  const handleEdit = (record) => {
    setEditData(record);
    setModalVisible(true);
  };

  const handleModalClose = () => {
    setModalVisible(false);
  };

  const showModalHandler = (record) => {
    setSelectedDeleteRecordId(record);
    setIsModalShow(true);
  };

  const handleOk = async () => {
    const response = await towingTariffService.deleteTariff(
      selectedDeleteRecordId
    );
    if (response.success) {
      notification.success({
        message: "Success",
        description: "Towing Tariff deleted successfully!",
        placement: "topRight",
      });
      setTariff((prevData) =>
        prevData.filter((item) => item.id !== selectedDeleteRecordId)
      );
    } else {
      const errors = response.data?.errors || [response.message];
      notification.error({
        message: "Error",
        description: `Error: ${errors.join(", ")}`,
        placement: "topRight",
      });
    }
    initialize(pagination.current, pagination.pageSize);
    setIsModalShow(false);
  };

  const handleCancel = () => {
    setIsModalShow(false);
  };

  const handleOpenModal = (id) => {
    // recordId = id
    getTariff(id);
    setIsModalVisible(true);
  };

  const handleCloseModal = () => {
    setIsModalVisible(false);
  };

  const deleteModal = (
    <Modal
      title={<div style={{ textAlign: "center" }}>Confirm</div>}
      open={isModalshow}
      onOk={handleOk}
      onCancel={handleCancel}
      centered
      style={{
        padding: "20px", // Adjust padding for smaller size
      }}
      width={300} // Adjust modal width
      footer={
        <div className="flex justify-center gap-3">
          <Button
            type="default"
            onClick={handleCancel}
            style={{ width: "30%" }}
          >
            Cancel
          </Button>
          <Button type="primary" onClick={handleOk} style={{ width: "30%" }}>
            Confirm
          </Button>
        </div>
      }
    >
      <p style={{ textAlign: "center" }}>
        Are you sure you want to delete this?
      </p>
    </Modal>
  );

  const initialize = async (page = 1, pageSize = pagination.current, search = null) => {
    try {
      setLoading(true);

      const { success, data, message } = await towingTariffService.fetch(
        page,
        pageSize,
        search
      );

      if (success) {
        if (data && data.data && data.data.length > 0) {
          setTariff(data.data);
          setPagination((prev) => ({
            ...prev,
            total: data.total,
            current: page,
            pageSize,
          }));
        } else {
          console.warn("No tariff data found.");
          setTariff([]);
        }
      } else {
        console.error(
          `Error: ${message || "Failed to fetch towing tariff data."}`
        );
      }
    } catch (error) {
      console.error("An unexpected error occurred:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    changeDocumentTitle("Towing Tariffs");
     if (refresh) {
      initialize(pagination.current, pagination.pageSize, search);
    }
    setRefresh(false)
  }, [refresh, search]);

  return (
    <div
      style={{
        padding: "5px",
        border: "1px solid #ccc",
        borderRadius: "8px",
        backgroundColor: "#FFFFFF",
      }}
    >
      <Row gutter={16} style={{ paddingTop: "5px" }}>
        <Col span={12}>
          <h1 style={{ fontWeight: "bold" }} className="pl-2 pt-3">
            Tariffs
          </h1>
        </Col>
      </Row>

      <div className="flex justify-end">
        <Input
          placeholder="Search by Auction & state"
          prefix={<SearchOutlined />}
          style={{
            width: "25%",
            borderRadius: "20px",
            fontSize: 14,
            margin: 10
          }}
          onChange={(e) => {
            setSearch(e.target.value)
            setRefresh(true);
          }}
        />
      </div>

      <Table
        columns={columns}
        scroll={{ x: "max-content" }}
        dataSource={tariff}
        rowKey="id"
        // pagination={{
        //   current: pagination.current,
        //   total: pagination.total,
        //   pageSize: pagination.pageSize,
        //   onChange: (page) => initialize(page, pagination.pageSize),
        //   showSizeChanger: false,
        // }}
        loading={loading}
        pagination={false}
        style={{ marginTop: "10px" }}
        footer={() => (
          <div className="flex justify-between items-center text-xs ">
            <div className=" text-gray-600">
              Showing {(pagination.current - 1) * pagination.pageSize + 1} to{" "}
              {Math.min(pagination.current * pagination.pageSize, pagination.total)} of{" "}
              {pagination.total} entries
            </div>
            <Pagination
              current={pagination.current}
              total={pagination.total}
              pageSize={pagination.pageSize}
              showSizeChanger={false}
              onChange={(page) => initialize(page, pagination.pageSize, search)}
              itemRender={(current, type, originalElement) => {
                if (type === "prev") return <a className="bg-[#EEEEEE] p-2 rounded-sm hover:text-primary">Previous</a>;
                if (type === "next") return <a className="bg-[#EEEEEE] p-2 rounded-sm hover:text-primary">Next</a>;
                return originalElement;
              }}
            />
          </div>
        )}
      />

      <TariffModalForm
        visible={modalVisible}
        onClose={handleModalClose}
        editData={editData}
        isEditMode={true}
        setRefresh={setRefresh}
      />
      {/* <EditTariff visible={isModaView} onClose={CloseModal} /> */}

      {/* view */}
      <Modal
        title={
          <div style={{ display: "flex", justifyContent: "center" }}>
            <span>View Tariff</span>
          </div>
        }
        open={isModalVisible}
        onCancel={handleCloseModal}
        style={{
          padding: "40px", // Adjust padding for smaller size
        }}
        width={450}
        footer={null}
        centered
      >
        <Row gutter={24}>
          <Col span={24}>
            <div
              style={{
                display: "flex",
                width: 320,
                border: "1px solid #d9d9d9",
                borderRadius: 4,
                marginBottom: 9,
                marginLeft: "auto",
                marginRight: "auto",
              }}
            >
              <div
                style={{
                  flex: 1,
                  padding: "4px 11px",
                  backgroundColor: "#f5f5f5",
                  borderRight: "1px solid #d9d9d9",
                  display: "flex",
                  alignItems: "left",
                }}
              >
                Auction:
              </div>
              <div
                style={{
                  flex: 1,
                  padding: "4px 11px",
                  display: "flex",
                  alignItems: "left",
                }}
              >
                {tariffRecord?.auctions}
              </div>
            </div>
          </Col>
          <Col span={24}>
            <div
              style={{
                display: "flex",
                width: 320,
                border: "1px solid #d9d9d9",
                borderRadius: 4,
                marginBottom: 9,
                marginLeft: "auto",
                marginRight: "auto",
              }}
            >
              <div
                style={{
                  flex: 1,
                  padding: "4px 11px",
                  backgroundColor: "#f5f5f5",
                  borderRight: "1px solid #d9d9d9",
                  display: "flex",
                  alignItems: "left",
                }}
              >
                State:
              </div>
              <div
                style={{
                  flex: 1,
                  padding: "4px 11px",
                  display: "flex",
                  alignItems: "left",
                }}
              >
                {tariffRecord?.state}
              </div>
            </div>
          </Col>
          <Col span={24}>
            <div
              style={{
                display: "flex",
                width: 320,
                border: "1px solid #d9d9d9",
                borderRadius: 4,
                marginBottom: 9,
                marginLeft: "auto",
                marginRight: "auto",
              }}
            >
              <div
                style={{
                  flex: 1,
                  padding: "4px 11px",
                  backgroundColor: "#f5f5f5",
                  borderRight: "1px solid #d9d9d9",
                  display: "flex",
                  alignItems: "left",
                }}
              >
                Ports:
              </div>
              <div
                style={{
                  flex: 1,
                  padding: "4px 11px",
                  display: "flex",
                  alignItems: "left",
                }}
              >
                {tariffRecord?.ports}
              </div>
            </div>
          </Col>
          <Col span={24}>
            <div
              style={{
                display: "flex",
                width: 320,
                border: "1px solid #d9d9d9",
                borderRadius: 4,
                marginBottom: 14,
                marginLeft: "auto",
                marginRight: "auto",
              }}
            >
              <div
                style={{
                  flex: 1,
                  padding: "4px 11px",
                  backgroundColor: "#f5f5f5",
                  borderRight: "1px solid #d9d9d9",
                  display: "flex",
                  alignItems: "left",
                }}
              >
                USD:
              </div>
              <div
                style={{
                  flex: 1,
                  padding: "4px 11px",
                  display: "flex",
                  alignItems: "left",
                }}
              >
                {tariffRecord?.usd}
              </div>
            </div>
          </Col>
          <Col span={24}>
            <div
              style={{
                display: "flex",
                width: 320,
                border: "1px solid #d9d9d9",
                borderRadius: 4,
                marginBottom: 20,
                marginLeft: "auto",
                marginRight: "auto",
              }}
            >
              <div
                style={{
                  flex: 1,
                  padding: "4px 11px",
                  backgroundColor: "#f5f5f5",
                  borderRight: "1px solid #d9d9d9",
                  display: "flex",
                  alignItems: "left",
                }}
              >
                Code: SC
              </div>
              <div
                style={{
                  flex: 1,
                  padding: "4px 11px",
                  display: "flex",
                  alignItems: "left",
                }}
              >
                {tariffRecord?.state_code}
              </div>
            </div>
          </Col>
        </Row>
        {/* <div
          className="flex justify-center"
          style={{ borderTop: "1px solid #d9d9d9", paddingTop: "20px" }}
        >
          <Button type="primary" size="small">
            <EditOutlined style={{ cursor: "pointer", fontSize: "16px" }} />
          </Button>
        </div> */}
      </Modal>

      {/* delete */}
      {deleteModal}
      {/* <FormModal visible={visible} onClose={onClose} /> */}
    </div>
  );
}
export default TowingTariff;
